export const baseUrl = () => {
	if (window.location.href.indexOf('localhost') > -1){
		
    	return 'http://localhost:8080/api';
    	
	} else if (window.location.href.indexOf('dev-') > -1){
		
		return 'http://dev-funeralback.mafr.group/api';
		
	} else if ((window.location.href.indexOf('dev-')> -1) || (window.location.href.indexOf('integration-') > -1)) {
		console.log('in UAt');
		return 'https://integration-memoire.votreassistance.fr/api';		
		
	} else if (window.location.href.indexOf('qual-') > -1){
		
		return 'https://qual-memoire.votreassistance.fr/api';
		
	} else{
		
		return 'https://memoire.votreassistance.fr/api';
	}
		
}

export const encodeUrlPassword = (pwd) => {
	// ! @ # $ % ^ & *
	pwd = pwd.replace('%', '%25');
	pwd = pwd.replace('!', '%21');
	pwd = pwd.replace('#', '%23');
	pwd = pwd.replace('$', '%24');
	pwd = pwd.replace('&', '%26');
	pwd = pwd.replace('@', '%40');
	pwd = pwd.replace('*', '%2A');
	pwd = pwd.replace('^', '%5E');
	
	return pwd;
}


// WEBPACK FOOTER //
// ./src/utils/baseUrl.js